// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as GeoRegion from "../../../common/store/GeoRegion.bs.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as VehicleConfig from "../../../common/store/VehicleConfig.bs.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as Languages$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as Lib$PorterinFusionkitSentry from "../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

var supportedLanguages = {
  hd: /* English */0,
  tl: {
    hd: /* Hindi */1,
    tl: {
      hd: /* Kannada */2,
      tl: {
        hd: /* Tamil */3,
        tl: {
          hd: /* Telugu */4,
          tl: {
            hd: /* Marathi */5,
            tl: {
              hd: /* Malayalam */6,
              tl: /* [] */0
            }
          }
        }
      }
    }
  }
};

function getVehicleCategory(urlParams) {
  var modifiedVehicleName = decodeURIComponent(Belt_Option.getWithDefault(Js_dict.get(urlParams, "category"), "Other"));
  var category = Js_dict.get(VehicleConfig.vehicleTypeCategoryMapper, modifiedVehicleName);
  if (category !== undefined) {
    return category;
  } else {
    return "Other";
  }
}

function getLanguage(urlParams) {
  var getSupportedLang = function (lang) {
    var language;
    try {
      language = Languages$Catalyst.fromCode(lang);
    }
    catch (exn){
      Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "Invalid Language");
      language = /* English */0;
    }
    if (List.mem(language, supportedLanguages)) {
      return language;
    } else {
      return /* English */0;
    }
  };
  var match = Js_dict.get(urlParams, "lang");
  var match$1 = Js_dict.get(urlParams, "language");
  if (match !== undefined) {
    return getSupportedLang(match);
  } else if (match$1 !== undefined) {
    return getSupportedLang(match$1);
  } else {
    return /* English */0;
  }
}

function getGeoRegion(urlParams) {
  try {
    var region = Js_dict.get(urlParams, "geo_region");
    if (region !== undefined) {
      return GeoRegion.fromString(window.decodeURIComponent(region));
    } else {
      return /* Other */20;
    }
  }
  catch (exn){
    Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "Geo region not supported");
    return /* Other */20;
  }
}

function getEligibilityStatus(urlParams) {
  var data = Js_dict.get(urlParams, "is_insurance_active");
  if (data === "true") {
    return /* Eligible */0;
  } else {
    return /* Ineligible */1;
  }
}

function getRoute(url) {
  var error = /* DefaultError */{
    _0: {
      title: /* Unauthorized */1,
      message: "Authentication Error"
    }
  };
  var match = url.path;
  if (!match) {
    return ;
  }
  if (match.hd !== "dashboard") {
    return ;
  }
  var match$1 = match.tl;
  if (!match$1) {
    return ;
  }
  if (match$1.hd !== "health_insurance") {
    return ;
  }
  var match$2 = match$1.tl;
  if (match$2) {
    if (match$2.tl) {
      return ;
    }
    var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
    var authToken = Js_dict.get(urlParams, "auth_token");
    if (authToken !== undefined) {
      return {
              TAG: /* InsuranceDashboard */6,
              _0: match$2.hd,
              _1: authToken,
              _2: getLanguage(urlParams),
              _3: getVehicleCategory(urlParams),
              _4: getEligibilityStatus(urlParams),
              _5: getGeoRegion(urlParams)
            };
    } else {
      return {
              TAG: /* DefaultErrorView */8,
              _0: error
            };
    }
  }
  var urlParams$1 = UrlUtils$Catalyst.getURLParams(url.search);
  var match$3 = Js_dict.get(urlParams$1, "uuid");
  var match$4 = Js_dict.get(urlParams$1, "auth_token");
  if (match$3 !== undefined && match$4 !== undefined) {
    return {
            TAG: /* InsuranceDashboard */6,
            _0: match$3,
            _1: match$4,
            _2: getLanguage(urlParams$1),
            _3: getVehicleCategory(urlParams$1),
            _4: getEligibilityStatus(urlParams$1),
            _5: getGeoRegion(urlParams$1)
          };
  } else {
    return {
            TAG: /* DefaultErrorView */8,
            _0: error
          };
  }
}

var RouteManager = {
  getVehicleCategory: getVehicleCategory,
  getLanguage: getLanguage,
  getGeoRegion: getGeoRegion,
  getEligibilityStatus: getEligibilityStatus,
  getRoute: getRoute
};

export {
  supportedLanguages ,
  RouteManager ,
  
}
/* VehicleConfig Not a pure module */
